<template>
  <section class="scene-instructions">

    <div class="overlay" @click.exact="onClose"></div>

    <transition name="instructions-fade">
      <div v-if="step === 1" class="instruction look">
        <div class="icon-wrap">
          <svg class="icon point">
            <use xlink:href="#instruction-look"></use>
          </svg>
        </div>

        <div class="description">
          Click and drag to look around
        </div>

        <div class="action close" @click="$emit('close')"></div>

        <div class="actions">
          <div class="action step-change next" @click="stepViewNext()">
            <div class="icon arrow"></div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="instructions-fade">
      <div v-if="step === 2" class="instruction move">
        <div class="icon-wrap">
          <svg class="icon point">
            <use xlink:href="#instruction-point"></use>
          </svg>

          <div class="move-icon-helper"></div>
        </div>

        <div class="description">
          Tap on the floor to move around
        </div>

        <div class="action close" @click="$emit('close')"></div>

        <div class="actions">
          <div class="action step-change previous" @click="stepViewPrevious()">
            <div class="icon arrow"></div>
          </div>

          <div class="action step-change next" @click="stepViewNext()">
            <div class="icon arrow"></div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="instructions-fade">
      <div v-if="step === 3" class="instruction interact">
        <div class="icon-wrap">
          <div class="interact-icon-helper">
            <div class="interact-icon-helper-box"></div>
          </div>

          <svg class="icon point">
            <use xlink:href="#instruction-point"></use>
          </svg>
        </div>

        <div class="description">
          Tap the glowing object to see more info
        </div>

        <div class="action close" @click="$emit('close')"></div>

        <div class="actions">
          <div class="action step-change previous" @click="stepViewPrevious()">
            <div class="icon arrow"></div>
          </div>
        </div>
      </div>
    </transition>

  </section>
</template>

<script>
  export default {
    name: 'SceneInstructions',

    props: ['show'],

    data() {
      return {
        step: 1,
        stepLast: 3
      }
    },

    methods: {
      onClose() {
        this.$emit('windowClose')
      },

      stepViewPrevious() {
        if (this.step > 1) {
          this.step--
        }
      },

      stepViewNext() {
        if (this.step < this.stepLast) {
          this.step++
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/styles/mixins";
  @import "../../assets/styles/variables";
  @import "../../assets/styles/main";

  .align-left {
    float: left;
  }

  .align-right {
    float: right;
  }

  .scene-instructions {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 2;

    .overlay {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }

    .instruction {
      background: linear-gradient(to bottom, #444 0%, rgba(68, 68, 68, 0.4) 100%);
      @include border-radius(30px);
      padding: 30px;
      width: 90%;
      position: absolute;
      top: 50%;
      left: 50%;
      color: #fff;
      @include transform-translate(-50%, -50%);

      .icon-wrap {
        width: 80px;
        height: 80px;
        margin: 30px auto;
        position: relative;

        .icon {
          width: 100%;
          height: 100%;
        }
      }

      .description {
        font-size: 2em;
        text-align: center;
        letter-spacing: 5px;
      }

      &.look {
        .icon.point {
          @include animation(2s animation-look cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite alternate);
        }
      }

      &.move {
        .move-icon-helper {
          width: 60px;
          height: 30px;
          border: 2px solid #e7e7e7;
          background-color: rgba(255, 255, 255, .5);
          @include border-radius(50%);
          margin: 0 auto;
        }

        .icon.point {
          width: 60px;
          height: 60px;
          @include animation(2s animation-move cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite alternate);
        }
      }

      &.interact {
        .interact-icon-helper {
          perspective: 100px;
        }

        .interact-icon-helper-box {
          width: 80px;
          height: 80px;
          border: 2px solid #e7e7e7;
          background-color: rgba(255, 255, 255, .5);
          @include box-shadow(0 0 0 0 rgba(255, 255, 255, .5));
          @include border-radius(10px);
          margin: 0 auto;
          transform-style: preserve-3d;
          @include transform(rotateY(25deg));
          @include animation(2s animation-interact-box cubic-bezier(0.68, -0.55, 0.27, 1.55) infinite alternate);
        }

        .icon.point {
          width: 60px;
          height: 60px;
          position: absolute;
          top: 30px;
          left: 100%;
          @include animation(2s animation-interact cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite alternate);
        }
      }

      .actions {
        display: flex;
        width: 100%;
        margin-top: 20px;
        align-items: center;
        justify-content: center;

        .action {
          background-color: rgba(255, 255, 255, 0.15);
          border: 2px solid transparent;
          @include border-radius(4px);
          color: #e7e7e7;
          cursor: pointer;
          width: 40px;
          height: 40px;
          margin: 0 20px;
          padding: 0;
          @include transition(.25s);

          .icon.arrow {
            width: 30px;
            height: 30px;
            margin: 2px;
          }

          &.previous {
            @include transform-rotate(180deg);
          }

          &:hover {
            border-color: #ffffff;
            color: #ffffff;
          }
        }
      }

      .action.close {
        position: absolute;
        top: 10px;
        right: 10px;
      }

      @include media("<tablet") {
        padding: 30px 10px;

        .description {
          font-size: 1.5em;
        }
      }
    }
  }

  @include keyframes(animation-look) {
    0% {
      @include transform-translate(50px, 0);
    }

    100% {
      @include transform-translate(-50px, 0);
    }
  }

  @include keyframes(animation-move) {
    0% {
      @include transform(translate(0, 0) rotate(180deg));
    }

    100% {
      @include transform(translate(0, -30px) rotate(180deg));
    }
  }

  @include keyframes(animation-interact) {
    0% {
      @include transform(translate(10px, 0));
    }

    100% {
      @include transform(translate(-60px, 0));
    }
  }

  @include keyframes(animation-interact-box) {
    0% {
      @include box-shadow(0 0 0 0 rgba(255, 255, 255, .5));
    }

    100% {
      @include box-shadow(0 0 0 5px rgba(255, 255, 255, .5));
    }
  }

  .instructions-fade {
    &-enter-active,
    &-leave-active {
      opacity: 1;
      @include transition(opacity .65s);
    }

    &-enter,
    &-leave-to {
      opacity: 0;
      @include transition(opacity .65s);
    }
  }
</style>
